/**
 * UpdateBanner – „Neue Version verfügbar“ statt erzwungenem Reload.
 * Quelle: utils/appUpdate.ts (Service Worker wartet oder /version.json weicht ab).
 */
import { Show } from 'solid-js';
import { useTranslation } from '../context/LanguageContext';
import { updateAvailable, updateApplying, applyUpdate } from '../utils/appUpdate';

export default function UpdateBanner() {
  const { t } = useTranslation();

  return (
    <Show when={updateAvailable() !== null}>
      <div class="upd-banner" role="status" aria-live="polite">
        <span class="upd-banner-icon" aria-hidden="true">🆕</span>
        <div class="upd-banner-text">
          <strong>{t('appUpdate.title')}</strong>
          <span>{t('appUpdate.text')}</span>
        </div>
        <button
          type="button"
          class="upd-banner-btn"
          onClick={() => void applyUpdate()}
          disabled={updateApplying()}
        >
          {updateApplying() ? '…' : t('appUpdate.reload')}
        </button>
      </div>
    </Show>
  );
}
